import { render } from "./MemberTop.vue?vue&type=template&id=45a61061&scoped=true"
import script from "./MemberTop.vue?vue&type=script&lang=js"
export * from "./MemberTop.vue?vue&type=script&lang=js"

import "./MemberTop.vue?vue&type=style&index=0&id=45a61061&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a61061"]])

export default __exports__